export default "__VITE_ASSET__CCT3fFU___"